// extracted by mini-css-extract-plugin
export default {"user-select":"styles_user-select__ixM2W"};